import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { type OptimizelyRole } from '../constants/accessGroups';
import { OrgSharedDataTag } from '../data/constants/tags';
export type UserAccessFlags = {
  hasEdgeAccessGroupContent: boolean;
  optimizelyRoles: OptimizelyRole[];
};
const getUserAccessFlags = async (): Promise<UserAccessFlags> => {
  const response = await fetch('/api/user-access-flags');
  if (!response.ok) {
    throw new Error('Failed to fetch user access flags');
  }
  return response.json();
};
export const useUserAccessFlags = t0 => {
  const $ = _c(3);
  const {
    enabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [OrgSharedDataTag.GET_USER_ACCESS_FLAGS];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      enabled,
      queryFn: getUserAccessFlags,
      queryKey: t1,
      retry: false,
      staleTime: Infinity,
      throwOnError: false
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data
  } = useQuery(t2);
  return data;
};